export enum SupplierInfoEventTypeEnum {
  LoadInfoFromId,
  OpenInfoDialog,
  CloseInfoDialog,
  InfoLoading,
  InfoLoaded,
}
